export default __webpack_public_path__ + "static/media/activeGridView.1f86c371.svg";